const TableTls = {
    
    /* ---- standard Table -------
        
    table   - options
                | colNames
                | colSum
                | colUnq
                | colShow
                | 
            - obj
                | [{obj with colNames...},{...},...]
            - arr
            - getArr()
            - getObj()
            - getTable(i,j,k,...)
            |
            |
    ------------------------------*/

    json2EtxtByObj(arrayOfObject,col2show){
        // Etxt: Excel text with tab and enter for copy and paste from/to excel
        // arrayOfObject [{},{},...] --- col2show['','',..] name of object
        var txt = '';
        for (let i = 0; i < arrayOfObject.length; i++) {
            for (let j = 0; j < col2show.length; j++) {
                txt += arrayOfObject[i][col2show[j]] + "\t";
            }
            txt += "\r\n";
        }
        return txt;
    },
    etxt2jsonByObj(etxt,col2show){
        var arrofObj = [];
        var rows = etxt.trim().split("\n");
        for (let i = 0; i < rows.length; i++) {
            arrofObj[i] = {};
            var cols = rows[i].split("\t");
            for (let j = 0; j < col2show.length && j < cols.length; j++) {
                arrofObj[i][col2show[j]] = cols[j];
            }
        }
        return arrofObj;
    },
    test() {
   
    },
  
  }
  
  
  export { TableTls };